import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';

const DateDisplayButton = React.forwardRef(({ value, onClick }, ref) => (
  <button
    type="button"
    className="btn btn-link p-0"
    ref={ref}
    onClick={(event) => {
      event.stopPropagation();
      onClick(event);
    }}
    style={{
      textDecoration: 'none',
      fontSize: '0.75rem',
      color: '#0f172a',
    }}
    title="Click to edit date"
  >
    {value || '-'}
  </button>
));

const InlineDateCell = ({ rowData, mixIns }) => {
  const rawDate = rowData?._issueDate || rowData?.date;

  const getParsedDate = () => {
    if (!rawDate) {
      return null;
    }

    const isoMoment = moment(rawDate, moment.ISO_8601, true);
    if (isoMoment.isValid()) {
      return isoMoment;
    }

    const formattedMoment = moment(rawDate, 'MM/DD/YYYY', true);
    if (formattedMoment.isValid()) {
      return formattedMoment;
    }

    return null;
  };

  const parsedDate = getParsedDate();
  const [selectedDate, setSelectedDate] = useState(parsedDate ? parsedDate.toDate() : null);

  useEffect(() => {
    const latest = getParsedDate();
    setSelectedDate(latest ? latest.toDate() : null);
  }, [rawDate]);

  const handleChange = (date) => {
    setSelectedDate(date);
    if (date && mixIns && typeof mixIns.onSaveDate === 'function') {
      const ymd = moment(date).format('YYYY-MM-DD');
      mixIns.onSaveDate(rowData._id, ymd);
    }
  };

  const displayDate = selectedDate ? moment(selectedDate).format('MM/DD/YYYY') : '-';

  return (
    <DatePicker
      selected={selectedDate}
      onChange={handleChange}
      customInput={<DateDisplayButton value={displayDate} />}
      calendarClassName="qt-datepicker"
      popperClassName="qt-datepicker-popper"
      popperPlacement="bottom-start"
      dateFormat="MM/dd/yyyy"
      shouldCloseOnScroll={false}
      popperModifiers={[]}
      popperContainer={({ children }) =>
        ReactDOM.createPortal(
          <div className="qt-datepicker-portal" style={{ zIndex: 2000, minWidth: 240 }}>
            {children}
          </div>,
          document.body
        )
      }
    />
  );
};

export default InlineDateCell;
